import { useCallback, useState } from 'react'

import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { IStepInfo } from '~/shared/types/commonTypes'

export const useBinaryChoiceStep = (stepInfo: IStepInfo) => {
  const [answer, setAnswer] = useState('')
  const { handleChange } = useDelayedContinue()
  const handleContinue = useNextStep(stepInfo)

  const handleAnswer = useCallback(
    (value: string) => {
      setAnswer(value)
      handleChange(value, handleContinue)
    },
    [handleChange, handleContinue],
  )

  return { answer, handleAnswer }
}
